module.exports = __webpack_public_path__ + "imgs/projthumb-blank.svg";